import { createClient } from '@supabase/supabase-js';

let rawUrl = process.env.REACT_APP_SUPABASE_URL || '';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Basic validation & normalization
if (!rawUrl) {
  console.warn('Supabase URL missing: please set REACT_APP_SUPABASE_URL in your .env file');
}

// Ensure URL includes protocol
if (rawUrl && !/^https?:\/\//i.test(rawUrl)) {
  rawUrl = `https://${rawUrl}`;
}

// Remove any accidental trailing `/rest/v1` or duplicate segments
const cleanedUrl = rawUrl.replace(/\/rest\/v1\/?$/i, '').replace(/\/+$/,'');

if (rawUrl !== cleanedUrl) {
  console.warn('Normalized REACT_APP_SUPABASE_URL by removing trailing /rest/v1 or slashes.');
}

if (!SUPABASE_ANON_KEY) {
  console.warn('Supabase anon key missing: please set REACT_APP_SUPABASE_ANON_KEY in your .env file');
}


export const supabase = createClient(cleanedUrl || '', SUPABASE_ANON_KEY || '');
